<div class="title-background" [class]="themeService.getTheme()">
  <div *ngIf="map && mapId != undefined" class="map-button-desktop">
    <div class="map-switch-container">
      <app-switch (emitValue)="switchMap($event)"/>
      <app-texts
        [texts]="[
              {text: ['Открыть карту', 'View on map']}
            ]"
        class="map-button-text"
      />
    </div>
  </div>
  <div class="background-container">
    <div
      class="background-image"
      [style.background-image]="'url(' + getBackground() + ')'"
      [style]="replaceObjectPosition(locationDto.cssStyleImage) + 'brightness(0.9);'">
    </div>
    <div class="content-layer" *ngIf="!interfaceService.getRouteOpenMap()">
      <div
        class="title-section"
        [style]="locationDto.services === false ||
        locationDto.services === undefined ? 'align-items: center' : ''">
        <span class="title-section-destination">
          <app-texts *ngIf="showDestination" [texts]="locationDto.destinationsText ?? []"/>
        </span>
        <app-texts
          [texts]="[
            {text: [locationDto.titleRu, locationDto.titleEn], fontStyle: 'italic', fontFamily: 'pds'}
          ]"
          class="main-title"
        />
        <div class="title-subtitle" *ngIf="locationDto.services !== undefined">
          <app-texts
            [texts]="[
              {text: [locationDto.descriptionRu, locationDto.descriptionEn]}
            ]"
          />
        </div>
        <div *ngIf="locationDto.button" class="explore-button-container">
          <div class="explore-button" (click)="onExploreClick()">
            <h4 class=" button-text">
              <app-texts
                [texts]="buttonText"
              />
            </h4>
            <div class="button-background">
              <div class="button-progress" [style.width.%]="countdown ?? 0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-container" *ngIf="mapId != undefined && interfaceService.getRouteOpenMap()">
      <iframe
        [src]="getSafeMapUrl()"
        class="map-iframe"
        loading="lazy">
      </iframe>
    </div>
  </div>
<!--  <div class="hotels-section" (click)="reserveHotel()" *ngIf="hotelSection && isMobile">-->
<!--    <div class="hotels-section-icon">-->
<!--      <app-icon [icon]="Icons.key" [invert]="true"/>-->
<!--    </div>-->
<!--    <app-texts [texts]="[-->
<!--      {text: ['RESERVE', 'RESERVE']},-->
<!--      {text: ['your', 'your'], fontFamily: 'pd', fontStyle: 'italic'},-->
<!--      {text: ['finest', 'finest']},-->
<!--      {text: ['hotel', 'hotel'], fontFamily: 'pd', fontStyle: 'italic'},-->
<!--    ]"/>-->
<!--  </div>-->
  <div class="mobile-map-section-container">
    <div
      class="mobile-map-section"
      *ngIf="map && mapId != undefined && isMobile && mapSection"
      [style]="!interfaceService.getRouteOpenMap() ? 'background: none' : ''"
    >
      <app-switch (emitValue)="switchMap($event)" [type]="'new'"/>
      <app-texts *ngIf="!interfaceService.getRouteOpenMap()" [texts]="[
      {text: ['View route map', 'View route map']}
    ]"/>
      <app-texts *ngIf="interfaceService.getRouteOpenMap()" [texts]="[
      {text: ['Exit route view', 'Exit route view']}
    ]"/>
    </div>
  </div>
</div>
